<template>
  <div class="anniversary-page">
    <!-- Header -->
    <div class="bg-mask" v-if="anniversaryList.length > 0"></div>
    <div class="header">
      <button class="back-btn" @click="$router.back()">返回</button>
      <div class="group-tabs-wrap">
        <div class="group-tabs">
          <div v-for="g in groupList" :key="g.groupId" class="group-tab" :class="{ active: groupId === g.groupId }" @click="switchGroup(g.groupId)">
            {{ g.groupName }}
          </div>
        </div>
      </div>
      <div class="header-right-space"></div>
    </div>

    <!-- 空状态 -->
    <div v-if="anniversaryList.length === 0" class="empty-state">
      <button class="primary-btn mt-10" @click="openCreateModal">+ 添加纪念日</button>
    </div>

    <!-- 核心内容区 -->
    <div v-else class="main-content">
      <!-- 左侧面板 -->
      <div class="left-panel">
        <div class="left-card glass-panel">
          <div class="left-top-header">
            <select v-model="currentId" @change="loadGroupContents" class="anniversary-select">
              <option v-for="item in anniversaryList" :key="item.id" :value="item.id">{{ item.title }}</option>
            </select>
            <div class="top-subtitle">{{ countdownData.text }}</div>
          </div>

          <div class="center-content">
            <div class="countdown-number">{{ countdownData.days }}</div>
            <div class="countdown-unit">{{ countdownData.unit }}</div>
            <div class="blessing-text" v-if="currentAnniversary.blessing">
              “ {{ currentAnniversary.blessing }} ”
            </div>
          </div>
          
          <button class="manage-btn-mini" @click="showManageModal = true">管理</button>
        </div>

        <div v-if="yearAgoRecord" class="year-ago-card glass-panel" @click="goToYearAgoDetail">
          <div class="polaroid-img">
            <img :src="yearAgoRecord.photoList?.[0] || '/default-avatar.webp'" alt="那年今日">
          </div>
          <div class="year-ago-info">
            <span class="year-label">去年的今天</span>
            <p>你们在「{{ yearAgoRecord.city }}」留下了足迹</p>
          </div>
        </div>
      </div>

      <!-- 右侧功能区 -->
      <div class="right-panel glass-panel">
        <div class="tabs">
          <div class="tab-item" :class="{ active: activeTab === 'gallery' }" @click="activeTab = 'gallery'">📸 岁月影汇</div>
          <div class="tab-item" :class="{ active: activeTab === 'wishes' }" @click="activeTab = 'wishes'">✨ 星语心愿</div>
          <div class="tab-item" :class="{ active: activeTab === 'letters' }" @click="activeTab = 'letters'">💌 时光信笺</div>
        </div>

        <div class="tab-content">
          <!-- 岁月影集 -->
          <div v-show="activeTab === 'gallery'" class="gallery-wrap bg-yingj">
            <div class="photo-wall">
<div class="photo-item" v-for="(img, idx) in (baseAnniversary.photo_list || [])" :key="idx" :style="getPhotoStyle(idx)">
                <img :src="img" @click="previewImgUrl = img" />
                <!-- 悬浮删除按钮 -->
                <div class="del-photo-btn" @click.stop="removePhoto(idx)">×</div>
              </div>
              <!-- 改为从足迹选取 -->
              <div class="photo-item add-photo" @click="openPhotoSelector">选取足迹相片</div>
            </div>
          </div>

          <!-- 星空许愿 -->
          <div v-show="activeTab === 'wishes'" class="wishes-wrap bg-xink">
            <div class="wishes-sky">
              <div class="star-wrapper" v-for="(wish, idx) in wishesList" :key="wish.id" :style="getStarStyle(idx)" @click="openWishDetail(wish)">
                <div class="star-shape"></div>
                <div class="star-tooltip">
                  <span class="author">{{ wish.nickname }}：</span>
                  {{ wish.content }}
                </div>
              </div>
              <div v-if="wishesList.length === 0" class="empty-tip-text">夜空很安静，快点亮第一颗星吧</div>
            </div>
            <div class="add-wish-box">
              <input v-model="newWishContent" type="text" placeholder="写下你们的心愿...50字以内" maxlength="50" @keyup.enter="submitWish">
              <button class="primary-btn mini-btn" @click="submitWish">许愿</button>
            </div>
          </div>

          <!-- 时光信箱 -->
          <div v-show="activeTab === 'letters'" class="letters-wrap bg-xingj">
            <div class="letter-grid">
              <div v-if="lettersList.length === 0" class="empty-tip-text">还没有信件，写一封吧</div>
              <div class="envelope-item" v-for="letter in lettersList" :key="letter.id" @click="openLetter(letter)">
                <div class="envelope" :style="{ backgroundColor: getEnvelopeColor(letter.user_phone) }">
                  <div class="envelope-flap"></div>
                  <div class="lock-icon" v-if="letter.isLocked">🔒</div>
                  <div class="wax-seal" v-if="!isRead(letter.id) && !letter.isLocked">💌</div>
                </div>
              </div>
            </div>
<button class="primary-btn mini-btn" style="width: auto; display: block; margin: 10px auto 0;" @click="openLetterModal">✍️ 写一封新信</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：从足迹选择照片 -->
    <div v-if="showPhotoSelector" class="mask" @click.self="showPhotoSelector = false">
      <div class="modal" style="width: 80vw; max-width: 800px;">
        <h3>从足迹中挑选相片</h3>
        <div class="selector-grid">
          <img 
            v-for="(img, idx) in allGroupPhotos" 
            :key="idx" 
            :src="img" 
            class="selector-img" 
            :class="{ selected: selectedPhotos.includes(img) }"
            @click="toggleSelectPhoto(img)" 
          />
        </div>
        <div v-if="allGroupPhotos.length === 0" style="text-align:center; padding:20px; color:#888;">该小组暂未上传过足迹照片</div>
        <div class="btn-row">
          <button class="cancel-btn" @click="showPhotoSelector = false">取消</button>
          <button class="submit-btn" @click="saveSelectedPhotos">确认选取 ({{ selectedPhotos.length }})</button>
        </div>
      </div>
    </div>

    <!-- 弹窗：查看许愿详情与回复 -->
    <div v-if="showWishDetailModal" class="mask" @click.self="showWishDetailModal = false">
      <div class="modal no-title-modal wide-modal">
        <div class="wish-main-card">
          <p class="wish-content-line">
            <span class="wish-author-inline">{{ currentWish.nickname }}：</span>
            “{{ currentWish.content }}”
          </p>
        </div>
        
        <div class="reply-list">
          <div v-for="reply in currentWish.replies" :key="reply.id" class="reply-item">
            <span class="reply-author">{{ reply.nickname }}：</span> {{ reply.content }}
          </div>
          <div v-if="!currentWish.replies || currentWish.replies.length === 0" class="no-reply">暂无回复，帮TA实现吧</div>
        </div>

        <div class="reply-input-box">
          <input v-model="replyContent" type="text" placeholder="留下祝福或帮TA实现...50字以内" maxlength="50" @keyup.enter="submitReply">
          <button class="primary-btn mini-btn" @click="submitReply">发送</button>
        </div>
      </div>
    </div>

    <!-- 其他弹窗保持不变 -->
    <div v-if="showCreateModal" class="mask" @click.self="showCreateModal = false">
      <div class="modal">
        <h3>添加纪念日</h3>
        <div class="form-item"><label>名称</label><input v-model="createForm.title" type="text" placeholder="例如：相遇相识、TA的生日" maxlength="10"></div>
        <div class="form-item"><label>日期</label><input v-model="createForm.targetDate" type="date"></div>
        <div class="form-item"><label>寄语</label><input v-model="createForm.blessing" type="text" placeholder="例如：执子之手，与子偕老" maxlength="30"></div>
        <div class="btn-row">
          <button class="cancel-btn" @click="showCreateModal = false">取消</button>
          <button class="submit-btn" @click="createAnniversary">确认</button>
        </div>
      </div>
    </div>

    <div v-if="showManageModal" class="mask" @click.self="showManageModal = false">
      <div class="modal">
        <h3>纪念日管理</h3>
        <div class="manage-list">
          <div class="manage-item" v-for="item in anniversaryList" :key="item.id">
            <span>{{ item.title }}</span>
            <button class="delete-btn" v-if="item.creator_phone === currentPhone" @click="deleteAnniversary(item)">删除</button>
          </div>
        </div>
        <div class="btn-row">
          <button class="cancel-btn" @click="showManageModal = false">关闭</button>
          <button class="submit-btn" @click="showManageModal = false; openCreateModal()">+ 新建</button>
        </div>
      </div>
    </div>

    <div v-if="showLetterModal" class="mask" @click.self="showLetterModal = false">
      <div class="modal">
        <h3>写一封信</h3>
        <textarea v-model="newLetterContent" rows="5" maxlength="1000" placeholder="写下你想对TA说的话...1000字以内"></textarea>
        <div class="form-item mt-10"><label>解锁时间（可选）</label><input type="datetime-local" v-model="newLetterUnlockTime"></div>
        <div class="btn-row">
          <button class="cancel-btn" @click="showLetterModal = false">取消</button>
          <button class="submit-btn" @click="submitLetter">发送</button>
        </div>
      </div>
    </div>

    <!-- 弹窗：看信 -->
    <div v-if="showReadLetterModal" class="mask" @click.self="showReadLetterModal = false">
      <div class="modal no-title-modal">
        <div class="reader-content">{{ currentLetter.content }}</div>
      </div>
    </div>

    <div v-if="previewImgUrl" class="mask" @click="previewImgUrl = ''">
      <img :src="previewImgUrl" class="preview-img" />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getMyGroupList } from '@/api/footprint'

export default {
  name: 'Anniversary',
  data() {
    return {
      groupList: [], groupId: '',
      anniversaryList: [], currentId: null,
      activeTab: 'gallery',
      yearAgoRecord: null,
      currentBaseId: null,
      
      wishesList: [], 
      lettersList: [],
      readLetters: [],
      
      // 照片选择器
      showPhotoSelector: false,
      allGroupPhotos: [],
      selectedPhotos: [],

      // 许愿与回复
      showWishDetailModal: false,
      currentWish: {},
      replyContent: '',

      showCreateModal: false,
      createForm: { title: '', targetDate: '', blessing: '' },
      showManageModal: false,
      newWishContent: '',
      showLetterModal: false, newLetterContent: '', newLetterUnlockTime: '',
      showReadLetterModal: false, currentLetter: {},
      previewImgUrl: '',
      envelopeColors: ['#f8bbd0', '#bbdefb', '#c8e6c9', '#ffe082', '#d1c4e9']
    }
  },
  computed: {
    currentAnniversary() { return this.anniversaryList.find(a => a.id === this.currentId) || {}; },
    baseAnniversary() {
      return this.anniversaryList.find(a => a.id === this.currentBaseId) || {};
    },
    currentPhone() { 
      try {
        const u = JSON.parse(localStorage.getItem('currentUser') || '{}');
        return u.phone || '';
      } catch (e) {
        return '';
      }
    },
    countdownData() {
      if (!this.currentAnniversary.target_date) return { days: 0, unit: '天', text: '' };
      const isBirthday = this.currentAnniversary.title.includes('生日');
      const targetDate = new Date(this.currentAnniversary.target_date);
      const now = new Date();
      targetDate.setHours(0,0,0,0); now.setHours(0,0,0,0);

      if (isBirthday) {
        let nextBirthday = new Date(now.getFullYear(), targetDate.getMonth(), targetDate.getDate());
        if (nextBirthday < now) nextBirthday.setFullYear(now.getFullYear() + 1);
        const diffDays = Math.ceil((nextBirthday - now) / (1000 * 60 * 60 * 24));
        const yearsOld = nextBirthday.getFullYear() - targetDate.getFullYear();
        return { days: diffDays === 0 ? '今' : diffDays, unit: diffDays === 0 ? '天快乐' : '天', text: `${yearsOld}岁生日 · 距离TA下一个生日` };
      } else {
        const diffDays = Math.floor((now - targetDate) / (1000 * 60 * 60 * 24));
        if (diffDays < 0) return { days: Math.abs(diffDays), unit: '天', text: '距离那一天还有' };
        let specialText = '距今已过去';
        if (diffDays === 0) specialText = '就是今天！';
        else if (diffDays === 100) specialText = '百天纪念';
        else if (diffDays % 365 === 0) specialText = `${diffDays / 365}周年`;
        else if (diffDays === 520) specialText = '520天';
        return { days: diffDays, unit: '天', text: `${targetDate.getFullYear()}年${targetDate.getMonth()+1}月${targetDate.getDate()}日 · ${specialText}` };
      }
    }
  },
  async mounted() {
    const savedRead = localStorage.getItem('read_letters');
    if (savedRead) this.readLetters = JSON.parse(savedRead);
    await this.loadGroups();
    await this.loadGroupContents();
  },
  methods: {
    async loadGroups() {
      try {
        const groups = await getMyGroupList();
        this.groupList = groups || [];
        if (this.groupList.length === 0) return this.$router.back();
        const queryId = this.$route.query.id || this.$route.query.groupId;
        this.groupId = (queryId && this.groupList.some(g => g.groupId === queryId)) ? queryId : this.groupList[0].groupId;
        await this.loadAnniversaries();
      } catch (e) { console.error(e); }
    },
    async switchGroup(id) {
      if (this.groupId === id) return;
      this.groupId = id; this.anniversaryList = []; this.currentId = null;
      await this.loadAnniversaries();
      await this.loadGroupContents();
    },
    async loadAnniversaries() {
      try {
        const res = await request.get(`/anniversary/list?groupId=${this.groupId}`);
        this.anniversaryList = res.data || [];
        if (this.anniversaryList.length > 0) {
          this.currentId = this.anniversaryList[0].id;
          this.currentBaseId = this.anniversaryList[this.anniversaryList.length - 1].id;
          this.loadGroupContents(); 
          this.checkYearAgo();
        }
      } catch (e) { console.error(e); }
    },
    async loadGroupContents() {
      if (this.anniversaryList.length === 0) return;
      
      // 👇 核心魔法：不管左侧当前选中哪个，右侧永远针对第一个创建的纪念日操作
      const baseAnniversaryId = this.anniversaryList[this.anniversaryList.length - 1].id;
      this.currentBaseId = baseAnniversaryId;

      try {
        const wRes = await request.get(`/anniversary/content?anniversaryId=${baseAnniversaryId}&type=wish`);
        this.wishesList = wRes.data || [];
        
        const lRes = await request.get(`/anniversary/content?anniversaryId=${baseAnniversaryId}&type=letter`);
        this.lettersList = lRes.data || [];
      } catch (e) { console.error(e); }
    },
    openCreateModal() { this.createForm = { title: '', targetDate: '', blessing: '' }; this.showCreateModal = true; },
    async createAnniversary() {
      if (!this.createForm.title || !this.createForm.targetDate) return alert('请填写完整信息');
      if (this.anniversaryList.length >= 5) {
        return alert('该小组最多只能创建 5 个纪念日');
      }

      // 前端拦截敏感词
      if (this.$hasSensitiveWord(this.createForm.title) || this.$hasSensitiveWord(this.createForm.blessing)) {
        return this.$showToast('包含违规词汇，请修改');
      }
      try {
        const res = await request.post('/anniversary/create', { groupId: this.groupId, ...this.createForm });
        if (res.success) { this.showCreateModal = false; await this.loadAnniversaries(); } else { alert(res.msg); }
      } catch (e) { alert('创建失败'); }
    },
    async deleteAnniversary(item) {
            const ok = await this.$showConfirm(`确定删除「${item.title}」吗？\n\n温馨提示：删除同小组内纪念日后右侧照片会重新分配，其他不变。`);
      if (!ok) return;
      try {
        const res = await request.delete(`/anniversary/${item.id}`);
        if (res.success) { this.showManageModal = false; await this.loadAnniversaries(); }
      } catch (e) { 
        this.$showToast('删除失败'); 
      }
    },
    
    // 相册相关
    async openPhotoSelector() {
      this.showPhotoSelector = true;
      this.selectedPhotos = [...(this.baseAnniversary.photo_list || [])];
      try {
        // 拉取小组足迹，提取所有照片
        const res = await request.get('/footprint', { params: { groupId: this.groupId } });
        let photos = [];
        (res.data || []).forEach(f => {
          if (f.photoList && f.photoList.length) photos = photos.concat(f.photoList);
        });
        this.allGroupPhotos = [...new Set(photos)]; // 去重
      } catch (e) { alert('拉取足迹照片失败'); }
    },
    toggleSelectPhoto(img) {
      const idx = this.selectedPhotos.indexOf(img);
      if (idx > -1) {
        // 已经选中了，就取消选中
        this.selectedPhotos.splice(idx, 1);
      } else {
        // 👇 核心限制：最多只能选 30 张
        if (this.selectedPhotos.length >= 30) {
          return alert('岁月影集最多只能挑选 30 张照片哦~');
        }
        this.selectedPhotos.push(img);
      }
    },
    async saveSelectedPhotos() {
      try {
        await request.post('/anniversary/update-photos', { anniversaryId: this.currentBaseId, photoList: this.selectedPhotos });
        this.baseAnniversary.photo_list = [...this.selectedPhotos];
        this.showPhotoSelector = false;
      } catch (e) { alert('保存失败'); }
    },
    async removePhoto(idx) {
      // 👇 把 currentAnniversary 换成 baseAnniversary
      const newList = [...(this.baseAnniversary.photo_list || [])];
      newList.splice(idx, 1);
      try {
        await request.post('/anniversary/update-photos', { anniversaryId: this.currentBaseId, photoList: newList });
        // 👇 把 currentAnniversary 换成 baseAnniversary
        this.baseAnniversary.photo_list = newList;
      } catch (e) { alert('移除失败'); }
    },

    // 许愿与回复相关
    async submitWish() {
      if (!this.newWishContent.trim()) return;
      if (this.$hasSensitiveWord(this.newWishContent)) return this.$showToast('包含违规词汇');
      
      try {
        const res = await request.post('/anniversary/content', { anniversaryId: this.currentBaseId, type: 'wish', content: this.newWishContent });
        if(res.success) { this.newWishContent = ''; await this.loadGroupContents(); }
        else alert(res.msg);
      } catch (e) { alert('失败'); }
    },
    openWishDetail(wish) {
      this.currentWish = wish;
      this.replyContent = '';
      this.showWishDetailModal = true;
    },
    async submitReply() {
      if (!this.replyContent.trim()) return;
      if (this.$hasSensitiveWord(this.replyContent)) return this.$showToast('包含违规词汇');

      try {
        const res = await request.post('/anniversary/content', { 
          anniversaryId: this.currentBaseId, 
          type: 'wish', 
          content: this.replyContent,
          parentId: this.currentWish.id 
        });
        if(res.success) {
          this.replyContent = '';
          // 重新拉取，并保持当前愿望弹窗打开
          await this.loadGroupContents();
          this.currentWish = this.wishesList.find(w => w.id === this.currentWish.id);
        } else { alert(res.msg); }
      } catch (e) { alert('回复失败'); }
    },

    // 信件相关
    openLetterModal() { this.newLetterContent = ''; this.newLetterUnlockTime = ''; this.showLetterModal = true; },
    async submitLetter() {
      if (!this.newLetterContent.trim()) return;
      if (this.$hasSensitiveWord(this.newLetterContent)) return this.$showToast('包含违规词汇');
      
      try {
        const res = await request.post('/anniversary/content', { anniversaryId: this.currentBaseId, type: 'letter', content: this.newLetterContent, unlockTime: this.newLetterUnlockTime || null });
        if(res.success) { this.showLetterModal = false; await this.loadGroupContents(); }
        else alert(res.msg);
      } catch (e) { alert('失败'); }
    },
    openLetter(letter) {
      if (letter.isLocked) return alert('未到开启时间');
      this.currentLetter = letter; this.showReadLetterModal = true;
      if (!this.readLetters.includes(letter.id)) {
        this.readLetters.push(letter.id); localStorage.setItem('read_letters', JSON.stringify(this.readLetters));
      }
    },
    isRead(id) { return this.readLetters.includes(id); },

    // 样式辅助
    getPhotoStyle(index) {
      const rots = [-5, 3, -2, 6, -4, 2];
      return { transform: `rotate(${rots[index % rots.length]}deg)` };
    },
    getStarStyle(index) {
      const seed = index * 17;
      return { left: `${(seed * 7) % 85 + 5}%`, top: `${(seed * 11) % 80 + 10}%`, animationDelay: `${(index % 5) * 0.4}s` };
    },
    getEnvelopeColor(phone) {
      if (!phone) return this.envelopeColors[0];
      let sum = 0; for (let i = 0; i < phone.length; i++) sum += phone.charCodeAt(i);
      return this.envelopeColors[sum % this.envelopeColors.length];
    },
    async checkYearAgo() {
      try {
        const res = await request.get('/footprint', { params: { groupId: this.groupId } });
        const today = new Date();
        const target = (res.data || []).find(f => {
          if (!f.arriveTime) return false;
          const d = new Date(f.arriveTime);
          return d.getMonth() === today.getMonth() && d.getDate() === today.getDate() && d.getFullYear() < today.getFullYear();
        });
        if (target) this.yearAgoRecord = target;
      } catch (e) {}
    },
    goToYearAgoDetail() {
      this.$router.push({ path: '/detail', query: { id: this.yearAgoRecord.id, province: this.yearAgoRecord.province, city: this.yearAgoRecord.city } });
    }
  }
}
</script>

<style scoped>
/* ================= 整体骨架 ================= */
.anniversary-page { 
  width: 100vw; 
  height: 100vh; 
  /* 👇 替换为道机背景图 */
  background-image: url("~@/assets/daoji.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex; 
  flex-direction: column; 
  overflow: hidden; 
  box-sizing: border-box; 
}
.header { height: clamp(44px, 6.5vh, 56px); display: flex; align-items: center; padding: 0 clamp(12px, 2vw, 24px); background: rgba(255,255,255,0.3); border-bottom: 1px solid rgba(255,255,255,0.4); backdrop-filter: blur(10px); z-index: 10; flex-shrink: 0; }
.back-btn { height: clamp(22px, 3vh, 26px); padding: 0 clamp(8px, 1.2vw, 14px); border-radius: 6px; background: linear-gradient(to bottom, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.15)); color: #2c3e50; font-weight: 600; border: 1px solid rgba(255, 255, 255, 0.8); cursor: pointer; font-size: 12px; }
.header-right-space { width: 60px; }
.group-tabs-wrap { flex: 1; overflow: hidden; display: flex; justify-content: center; }
.group-tabs { display: flex; gap: 8px; overflow-x: auto; white-space: nowrap; scrollbar-width: none; padding: 4px 0; }
.group-tabs::-webkit-scrollbar { display: none; }
.group-tab { padding: 2px 6px; border-radius: 12px; background: rgba(255,255,255,0.6); border: 1px solid rgba(255,255,255,0.9); font-size: 12px; font-weight: bold; color: #666; cursor: pointer; transition: all 0.2s; flex-shrink: 0; }
.group-tab.active { background: #d6486b; color: #fff; border-color: #d6486b; box-shadow: 0 2px 6px rgba(214, 72, 107, 0.3); }

/* ================= 核心内容区 ================= */
.main-content { flex: 1; display: flex; padding: 8px clamp(6px, 1vw, 16px) 12px; gap: clamp(8px, 1.2vw, 16px); overflow: hidden; box-sizing: border-box; z-index: 2; }
.glass-panel { background: rgba(255, 255, 255, 0.75); backdrop-filter: blur(20px); border: 1px solid rgba(255, 255, 255, 0.8); border-radius: 16px; box-shadow: 0 8px 20px rgba(0,0,0,0.06), inset 0 2px 4px rgba(255,255,255,0.6); }

/* ================= 左侧面板 ================= */
.left-panel { flex: 0 0 32%; display: flex; flex-direction: column; gap: 12px; }
.left-card { flex: 1; display: flex; flex-direction: column; padding: 16px; position: relative; }
.left-top-header { display: flex; flex-direction: column; gap: 6px; margin-bottom: 10px; width: 100%; align-items: flex-start; }
.anniversary-select { align-self: center; padding: 4px 10px; border-radius: 6px; background: rgba(255,255,255,0.8); border: 1px solid rgba(255,255,255,0.9); color: #d6486b; font-weight: bold; font-size: 13px; outline: none; cursor: pointer; }
.top-subtitle { font-size: 12px; color: #666; font-weight: bold; padding-left: 2px; text-align: left; }

.center-content { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #d6486b; text-shadow: 0 2px 10px rgba(214, 72, 107, 0.3); }
.countdown-number { font-size: clamp(50px, 8vw, 90px); font-weight: 900; line-height: 1; }
.countdown-unit { font-size: clamp(14px, 1.8vw, 18px); font-weight: 600; margin-top: 4px; margin-bottom: 16px; }
.blessing-text { font-size: clamp(13px, 1.3vw, 15px); color: #2c3e50; font-weight: bold; text-align: center; max-width: 90%; }

.manage-btn-mini { position: absolute; right: 16px; bottom: 16px; background: #8bc34a; color: #fff; border: none; padding: 2px 6px; border-radius: 6px; cursor: pointer; font-size: 10px; box-shadow: 0 2px 6px rgba(139, 195, 74, 0.4); transition: 0.2s; }
.manage-btn-mini:hover { background: #7cb342; transform: translateY(-1px); }

.year-ago-card { display: flex; padding: 10px; gap: 12px; align-items: center; cursor: pointer; transition: 0.2s; flex-shrink: 0; }
.year-ago-card:hover { transform: translateY(-2px); }
.polaroid-img { width: 60px; height: 60px; background: #fff; padding: 3px; border-radius: 4px; box-shadow: 0 2px 6px rgba(0,0,0,0.1); transform: rotate(-3deg); flex-shrink: 0; }
.polaroid-img img { width: 100%; height: 100%; object-fit: cover; }
.year-label { font-size: 11px; color: #888; }
.year-ago-info p { margin: 2px 0 0 0; font-size: 12px; color: #333; font-weight: bold; }

/* ================= 右侧面板 ================= */
.right-panel { flex: 1; display: flex; flex-direction: column; overflow: hidden; padding: 14px; }
.tabs { display: flex; gap: 8px; margin-bottom: 10px; border-bottom: 1px solid rgba(0,0,0,0.05); padding-bottom: 8px; z-index: 2; }
.tab-item { padding: 4px 12px; border-radius: 14px; cursor: pointer; font-weight: bold; font-size: clamp(11px, 1.1vw, 13px); color: #666; background: rgba(255,255,255,0.6); transition: all 0.2s; }
.tab-item.active { background: #d6486b; color: #fff; box-shadow: 0 2px 6px rgba(214, 72, 107, 0.3); }

.tab-content { flex: 1; overflow: hidden; position: relative; border-radius: 8px; }
.bg-yingj { background: url("~@/assets/yingj.webp") center/cover no-repeat; }
.bg-xink { background: url("~@/assets/xink.webp") center/cover no-repeat; }
.bg-xingj { background: url("~@/assets/xingj.webp") center/cover no-repeat; }

/* ================= 岁月影集 ================= */
.gallery-wrap { display: flex; flex-direction: column; height: 100%; padding: 10px; }
.photo-wall { display: flex; flex-wrap: wrap; align-content: flex-start; gap: 10px; height: 100%; overflow-y: auto; padding: 10px; }
.photo-wall::-webkit-scrollbar { display: none; }
.photo-item { flex: 0 0 auto; width: clamp(70px, 10vw, 100px); height: clamp(70px, 10vw, 100px); background: #fff; padding: 3px 3px 14px 3px; box-shadow: 0 4px 10px rgba(0,0,0,0.2); cursor: pointer; border-radius: 2px; transition: transform 0.2s, z-index 0.2s; position: relative; }
.photo-item:hover { transform: scale(1.1) rotate(0deg) !important; z-index: 100 !important; }
.photo-item img { width: 100%; height: 100%; object-fit: cover; }
.del-photo-btn { position: absolute; top: -5px; right: -5px; width: 18px; height: 18px; background: #f56c6c; color: #fff; border-radius: 50%; font-size: 12px; display: flex; align-items: center; justify-content: center; cursor: pointer; opacity: 0; transition: 0.2s; }
.photo-item:hover .del-photo-btn { opacity: 1; }
.add-photo { display: flex; align-items: center; justify-content: center; border: 2px dashed rgba(255,255,255,0.8); background: rgba(255,255,255,0.3); color: #fff; text-shadow: 0 1px 2px rgba(0,0,0,0.3); font-size: 12px; padding: 0; transform: none !important; }
.add-photo:hover { border-color: #fff; color: #fff; background: rgba(255,255,255,0.5); }

/* 相片选择器 */
.selector-grid { display: flex; flex-wrap: wrap; gap: 10px; max-height: 50vh; overflow-y: auto; margin-bottom: 16px; padding: 4px; }
.selector-img { width: 80px; height: 80px; object-fit: cover; border-radius: 4px; cursor: pointer; border: 3px solid transparent; transition: 0.2s; }
.selector-img.selected { border-color: #d6486b; box-shadow: 0 0 8px rgba(214, 72, 107, 0.5); }

/* ================= 星空许愿 ================= */
.wishes-wrap { display: flex; flex-direction: column; height: 100%; padding: 10px; box-sizing: border-box; }
.wishes-sky { flex: 1; position: relative; border-radius: 12px; margin-bottom: 10px; overflow: hidden; }
.star-wrapper { position: absolute; width: 16px; height: 16px; cursor: pointer; z-index: 2; }
.star-shape { width: 100%; height: 100%; background-color: #ffe600; clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%); animation: twinkleStar 1.5s infinite alternate ease-in-out; filter: drop-shadow(0 0 6px #ffe600); }
@keyframes twinkleStar { 0% { opacity: 0.4; transform: scale(0.8); } 100% { opacity: 1; transform: scale(1.2); } }
.star-tooltip { display: none; position: absolute; bottom: 25px; left: 50%; transform: translateX(-50%); background: rgba(255,255,255,0.95); padding: 6px 10px; border-radius: 6px; font-size: 12px; white-space: nowrap; box-shadow: 0 4px 12px rgba(0,0,0,0.3); z-index: 10; color: #333; }
.star-wrapper:hover .star-tooltip { display: block; }
.author { color: #d6486b; font-weight: bold; }
.add-wish-box { display: flex; gap: 8px; position: relative; z-index: 2; }
.add-wish-box input { flex: 1; height: 32px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.5); background: rgba(255,255,255,0.8); padding: 0 12px; outline: none; font-size: 13px; }

/* 许愿详情与回复 */
.wish-main-card { text-align: center; padding: 8px 12px; background: rgba(255,255,255,0.5); border-radius: 8px; margin-bottom: 8px; }
.wish-content-line { 
  font-size: 12px;  
  color: #333; 
  margin: 0; 
  line-height: 1.4;
}
.wish-content-text { font-size: 10px; font-weight: bold; color: #d6486b; margin: 0 0 8px 0; }
.wish-author-text { font-size: 10px; color: #666; margin: 0; }
.reply-list { max-height: 300px; overflow-y: auto; margin-bottom: 12px; padding: 8px; background: rgba(0,0,0,0.03); border-radius: 8px; flex: 1;}
.reply-list::-webkit-scrollbar { display: none; }
.reply-item { font-size: 11px; color: #333; margin-bottom: 8px; line-height: 1.4; }
.reply-author { font-weight: bold; color: #409eff; }
.no-reply { text-align: center; color: #999; font-size: 10px; }
.reply-input-box { display: flex; gap: 8px; }
.reply-input-box input { flex: 1; height: 32px; border-radius: 6px; border: 1px solid #ccc; padding: 0 12px; outline: none; }

/* ================= 时光信箱 ================= */
.letters-wrap { display: flex; flex-direction: column; height: 100%; padding: 10px; box-sizing: border-box; }
.letter-grid { display: flex; flex-wrap: wrap; gap: 16px; margin-bottom: 10px; flex: 1; overflow-y: auto; align-content: flex-start; }
.letter-grid::-webkit-scrollbar { display: none; }
.envelope-item { width: 80px; height: 55px; cursor: pointer; position: relative; transition: transform 0.2s; perspective: 1000px; }
.envelope-item:hover { transform: translateY(-4px) scale(1.05); }
.envelope { width: 100%; height: 100%; position: relative; border-radius: 4px; box-shadow: 0 4px 10px rgba(0,0,0,0.2); }
.envelope-flap { position: absolute; top: 0; left: 0; width: 0; height: 0; border-left: 40px solid transparent; border-right: 40px solid transparent; border-top: 28px solid rgba(255,255,255,0.6); border-radius: 4px 4px 0 0; }
.wax-seal { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 24px; height: 24px; background: #c0392b; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; box-shadow: 0 2px 4px rgba(0,0,0,0.3), inset 0 -2px 4px rgba(0,0,0,0.4); border: 2px solid #e74c3c; color: #fff; }
.lock-icon { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); font-size: 20px; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5)); }

/* ================= 按钮与弹窗 ================= */
.primary-btn { background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(214, 72, 107, 0.85); color: #fff; border: 1px solid rgba(255,255,255,0.4); border-radius: 6px; padding: 6px 16px; font-weight: bold; cursor: pointer; box-shadow: 0 3px 8px rgba(214, 72, 107, 0.2); font-size: 13px; }
.primary-btn:hover { transform: translateY(-1px); }
.mini-btn { padding: 4px 12px; font-size: 12px; }
.mt-10 { margin-top: 10px; }
.empty-tip-text { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #fff; text-shadow: 0 2px 4px rgba(0,0,0,0.5); font-size: 13px; width: 100%; text-align: center; z-index: 2;}
.empty-state { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #555; padding-top: 50vh; transform: translateX(-170px); }
.empty-icon { font-size: 60px; margin-bottom: 20px; animation: float 2s infinite ease-in-out; }
@keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }

.mask { position: fixed; inset: 0; background: rgba(0,0,0,0.45); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal { 
  background: rgba(247,243,233,0.98); 
  background-image: url("~@/assets/subtle.webp"); 
  background-size: 420px auto; 
  padding: 12px 16px; /* 👈 压缩内边距 */
  border-radius: 12px; 
  width: clamp(260px, 45vw, 380px); /* 👈 宽度适当缩小 */
  max-height: 85vh; /* 防止顶破屏幕 */
  overflow-y: auto; 
  box-shadow: 0 10px 30px rgba(0,0,0,0.25); 
  box-sizing: border-box;
}
.modal::-webkit-scrollbar { display: none; }

/* 弹窗标题 */
.modal h3 { 
  margin: 0 0 10px 0; /* 👈 减小下边距 */
  text-align: center; 
  color: #2c3e50; 
  font-size: clamp(14px, 1.5vw, 16px); 
}

/* 表单项间距 */
.form-item { margin-bottom: 8px; /* 👈 从 16px 减到 8px */ }

/* 标签文字 */
.form-item label { 
  display: block; 
  font-size: clamp(11px, 1.1vw, 13px); 
  font-weight: bold; 
  margin-bottom: 4px; /* 👈 减小间距 */
}

/* 输入框 & 文本域 */
.form-item input, .modal textarea { 
  width: 100%; 
  padding: 6px 10px; /* 👈 压缩内边距 */
  height: clamp(28px, 4vh, 32px); /* 👈 强行锁定输入框高度 */
  font-size: clamp(12px, 1.2vw, 14px); 
  border: 1px solid #ccc; 
  border-radius: 6px; 
  outline: none; 
  box-sizing: border-box; 
}
.modal textarea { resize: none; }
.btn-row { 
  display: flex; 
  justify-content: center; 
  gap: 12px; 
  margin-top: 12px; /* 👈 从 20px 减到 12px */
}
.cancel-btn { background: rgba(144, 147, 153, 0.85); color: #fff; border: none;   cursor: pointer; }
.submit-btn { background: rgba(64, 158, 255, 0.85); color: #fff; border: none;   cursor: pointer; }
.cancel-btn, .submit-btn { 
  padding: clamp(4px, 1vh, 6px) clamp(16px, 2vw, 24px); 
  font-size: clamp(12px, 1.2vw, 14px); 
  border-radius: 6px; 
}
.reader-content { max-height: 300px; overflow-y: auto; line-height: 1.6; color: #333; font-size: 14px; padding: 12px; background: rgba(255,255,255,0.5); border-radius: 8px; }
.preview-img { max-width: 90vw; max-height: 90vh; border-radius: 8px; }

.manage-list { max-height: 200px; overflow-y: auto; border: 1px solid rgba(0,0,0,0.05); border-radius: 8px; }
.manage-item { display: flex; justify-content: space-between; align-items: center; padding: 6px 12px; border-bottom: 1px solid rgba(0,0,0,0.05); }
.manage-item span { 
  font-size: clamp(12px, 1.1vw, 14px); /* 👈 字号减小并自适应 */
  font-weight: normal; /* 👈 取消加粗 */
  color: #333; 
  line-height: 1.2; /* 👈 降低行距 */
}
.delete-btn { background: #f56c6c; color: #fff; border: none; padding: 3px 8px; border-radius: 4px; cursor: pointer; font-size: clamp(11px, 1vw, 12px);}

/* 统一无标题弹窗样式 */
.no-title-modal {
  padding: 16px 20px; 
  display: flex;
  flex-direction: column;
  max-height: 75vh;
   width: clamp(320px, 50vw, 450px); /* 统一宽度 */
}
/* 星空许愿弹窗加宽 */
.wide-modal {
  width: clamp(320px, 80vw, 550px) !important;
  min-height: 250px; /* 给一个保底高度，看起来不寒酸 */
  max-height: 75vh;
  height: auto !important;
}
.no-title-modal .reader-content {
  flex: 1;
  overflow-y: auto;
  max-height: none;
  padding: 16px;
}
.bg-mask {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.45); /* 👈 白色的半透明遮罩 */
  backdrop-filter: blur(10px); /* 👈 让背后的照片变模糊 */
  -webkit-backdrop-filter: blur(10px);
  z-index: 1; /* 保证在背景之上，内容之下 */
  pointer-events: none; /* 防止挡住鼠标点击 */
}
</style>